var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.85 65.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#00a193;}.cls-1{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.96,
    y: 17.3,
    width: 48.93,
    height: 32.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.27,10a3.05,3.05,0,1,0-3-3.05,3.06,3.06,0,0,0,3,3.05Zm0-4.18a1.13,1.13,0,1,1-1.13,1.13,1.13,1.13,0,0,1,1.13-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.53,10a3.05,3.05,0,1,0-3.06-3.05A3.06,3.06,0,0,0,25.53,10Zm0-4.18a1.13,1.13,0,1,1-1.14,1.13,1.13,1.13,0,0,1,1.14-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.78,10a3.05,3.05,0,1,0-3.05-3.05A3.06,3.06,0,0,0,34.78,10Zm0-4.18a1.13,1.13,0,1,1-1.14,1.13,1.13,1.13,0,0,1,1.14-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,0H2.88A2.88,2.88,0,0,0,0,2.88V58.33A2.88,2.88,0,0,0,2.88,61.2H4.93v2.17A2.1,2.1,0,0,0,7,65.47H9a2.1,2.1,0,0,0,2.1-2.1V61.2H28.85a1,1,0,1,0,0-1.91h-26a1,1,0,0,1-1-1V55.49h47v2.84a1,1,0,0,1-1,1H32.68a1,1,0,0,0,0,1.91h7.26v2.17a2.1,2.1,0,0,0,2.1,2.1h2a2.1,2.1,0,0,0,2.1-2.1V61.2H48a2.88,2.88,0,0,0,2.87-2.87V2.88A2.88,2.88,0,0,0,48,0ZM9.2,61.2v2.17a.19.19,0,0,1-.19.18H7a.18.18,0,0,1-.18-.18V61.2Zm35,2.17a.18.18,0,0,1-.18.18H42a.18.18,0,0,1-.18-.18V61.2H44.2Zm4.73-29.62H45a11.55,11.55,0,0,0-19.53-8,11.55,11.55,0,0,0-19.53,8h-4V18.26h47ZM22.09,36.46a.66.66,0,0,0-.12.17,5.18,5.18,0,0,1-9.45-1H22c0,.26.08.53.14.79Zm-9.81-2.71A5.19,5.19,0,0,1,22,31.53a.52.52,0,0,0,.12.17,11.6,11.6,0,0,0-.24,2.05Zm10.54-4.32a7.1,7.1,0,0,0-12.46,4.32H7.82a9.64,9.64,0,0,1,16.33-6.6,12.35,12.35,0,0,0-1.33,2.28ZM10.53,35.67a7.1,7.1,0,0,0,12.29,3.06A12,12,0,0,0,24.15,41a9.54,9.54,0,0,1-6.7,2.71,9.65,9.65,0,0,1-9.51-8Zm13.36,0h2.59a7.1,7.1,0,0,0,13.84,0h2.59a9.64,9.64,0,0,1-19,0Zm14.45,0a5.18,5.18,0,0,1-9.87,0ZM28.23,33.75a5.18,5.18,0,0,1,10.34,0Zm12.27,0a7.1,7.1,0,0,0-14.19,0H23.77a9.64,9.64,0,0,1,19.26,0ZM1.92,35.67H6a11.58,11.58,0,0,0,11.45,10,11.45,11.45,0,0,0,8-3.2,11.55,11.55,0,0,0,19.42-6.77h4.08V48.93h-47Zm1-33.75H48a1,1,0,0,1,1,1v8.89H9.73a1,1,0,1,0,0,1.91h39.2v2.66h-47V13.68h4a1,1,0,1,0,0-1.91h-4V2.88a1,1,0,0,1,1-1Zm-1,51.65V50.84h47v2.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50);
export default __webpack_public_path__ + "static/media/50.9889298f62a882739e76e4d306a06159.svg";
export { ForwardRef as ReactComponent };